/// <reference types="./arrow_up_line.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function arrow_up_line() {
  return $svg.square(
    20,
    "<path d=\"M9.99999 9.64854L5.87499 13.7735L4.69666 12.5952L9.99999 7.29187L15.3033 12.5952L14.125 13.7735L9.99999 9.64854Z\" fill=\"currentColor\"/>",
  );
}
